export const $importMap = document.getElementById('main-importmap');
const _importMapUrl = $importMap ? $importMap.getAttribute('src') : 'http://doesnt-exist.walmartlabs.com';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const mfeConfig = window.mfeConfig;
const staticServerOrigin = new URL(mfeConfig.STATIC_SERVER).origin;
export const importMapUrl = _importMapUrl.startsWith('http')
    ? _importMapUrl
    : new URL(_importMapUrl, staticServerOrigin).toString();
